import api from '../../utils/api';
import store from '../index';

const state = {};

const getters = {};

const mutations = {};

const actions = {
	async refundWalletFetchApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api
			.get(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('addPreviousModal', store.state.nextModal.api);
				commit('setNextModal', response.next_step);
				commit('setIsLoading', false);
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	},

	async refundWalletPostApi({ commit, dispatch }, data) {
		commit('setIsLoading', true);
		commit('resetReq', null, { root: true });
		commit('reqInit', null, { root: true });
		commit('clearErrorMessage', null, { root: true });
		return api
			.post(`${data.api}`, data)
			.then((response) => {
				if (!response.ok) {
					return Promise.reject(response);
				}
				commit('reqSuccess', null, { root: true });
				return response.json();
			})
			.then(async (response) => {
				commit('setIsLoading', false);
				if (response?.data?.token) {
					commit('updateToken', response?.data?.token);
				}
				if (!store.state.userPartnerToken) {
					const token = response && response.data && response.data.token ? response.data.token : null;
					await commit('setUserPartnerToken', token);
				}
				commit('addPreviousModal', store.state.nextModal);
				commit('setNextModal', response.next_step);
				if (response.next_step.name === 'FINAL') {
					commit('setIsLoading', false);
					if (response.data.status === 'successful') {
						commit('setIframeResponseOnSuccess', {
							status: true,
							type: 'SUCCESS',
							data: {
								status: 'successful',
								data: {
									reference: response.data.reference,
									redirect_url: response.data.redirect_url ? response.data.redirect_url : false
								}
							}
						});
					} else {
						commit('setIframeResponseOnError', {
							message: response.message,
							type: 'ERROR'
						});
					}
				}
				return true;
			})
			.catch(async (response) => {
				const error = await response.text().then((text) => text);
				return Promise.reject(error);
			})
			.catch((error) => {
				dispatch('catchTypeError', error);
			});
	}
};

export default {
	actions,
	state,
	mutations,
	getters
};
